import {Repository} from './Repository'

export default {
  save (formData) {
    return Repository.post(`contactus/saveContactForm`, formData)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/contactUsRepository.js